export default __webpack_public_path__ + "static/wicked-fast-029336a5360e4479dcf120f69de63978.jpg";